import {jwtDecode} from "jwt-decode";

export const VerifyJWTToken = async (token, setAuth) => {
  try {
    const decoded = jwtDecode(token);
    // Check if the token is expired
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    if (decoded.exp && decoded.exp < currentTime) {
      console.error("Token has expired");
      return false;
    }
    /* Check the token for valid signature on server side and only then finaly validate */
   const response = await fetch(process.env.REACT_APP_BACKEND_URL+"/api/verify-token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    const data = await response.json();
    if (!data.valid) {
      console.error("Token signature is invalid");
      return false;
    }
    setAuth(true);
    return true; // Token is valid
  } catch (err) {
    console.error("Invalid token:", err);
    return true;
  }
};